import { linkEditing } from '@yola/ws-sdk';
import resolveInitialConfig from 'src/js/modules/common/helpers/resolve-initial-config';
import linkTypes from '../constants/link-types';
import fieldNames from '../constants/field-names';

const { BLANK, NOFOLLOW } = linkEditing.constants.common;

const getValuesByLinkType = (linkType, linkConfig) => {
  const { reference, pageId, download, target, rel } = linkConfig;
  const isTargetBlank = target === BLANK;
  const isNofollow = rel === NOFOLLOW;
  const values = {};

  switch (linkType) {
    case linkTypes.ANCHOR: {
      if (reference) {
        values[fieldNames.ANCHOR_REFERENCE] = reference;
      }

      if (pageId) {
        values[fieldNames.ANCHOR_PAGE_ID] = pageId;
      }

      break;
    }

    case linkTypes.EXTERNAL: {
      if (reference) {
        values[fieldNames.EXTERNAL_URL] = reference;
      }

      values[fieldNames.EXTERNAL_TARGET_BLANK_SWITCHER] = isTargetBlank;
      values[fieldNames.EXTERNAL_NOFOLLOW_SWITCHER] = isNofollow;

      break;
    }

    case linkTypes.PHONE: {
      if (reference) {
        values[fieldNames.PHONE_REFERENCE] = reference;
      }

      break;
    }

    case linkTypes.MAIL: {
      if (reference) {
        values[fieldNames.MAIL_REFERENCE] = reference;
      }

      break;
    }

    case linkTypes.PAGE: {
      if (reference) {
        values[fieldNames.PAGE_REFERENCE] = reference;
      }

      break;
    }

    case linkTypes.DOWNLOAD: {
      if (download) {
        values[fieldNames.DOWNLOAD_FILE_NAME] = download;
      }

      if (reference) {
        values[fieldNames.DOWNLOAD_REFERENCE] = reference;
      }

      break;
    }

    default:
      break;
  }

  return values;
};

const extractFieldsValuesFromLinkConfig = (linkConfig) => {
  if (!linkConfig || !linkConfig.linkType) {
    return {};
  }

  const resolvedConfig = resolveInitialConfig(linkConfig);

  if (!resolvedConfig.linkType) {
    return {};
  }

  const { linkType } = resolvedConfig;
  const valuesByLinkType = getValuesByLinkType(linkType, resolvedConfig);

  return {
    [fieldNames.LINK_TYPE]: linkType,
    ...valuesByLinkType,
  };
};

export default extractFieldsValuesFromLinkConfig;
